<template>
  <div>
    <el-row>
      <el-col>
        <el-button type="primary" size="medium" style="margin-top:20px" @click="addCheckout">新增匹配</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="newTableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="400" min-width="50"></el-table-column>
          <el-table-column label="校验项" prop="QUALIFICATION_NAME"></el-table-column>
          <el-table-column label="是否为必填" prop="STATUS ">
            <template slot-scope="scope">
              <span v-if="scope.row.STATUS == 1">必填</span>
              <span v-if="scope.row.STATUS == 2">非必填</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="remove(scope.row)">解除匹配</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @size-change="sizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 新增匹配 -->
    <el-dialog :visible.sync="addAptitudeDialog" @close="addAptitudeDialog = false" title="新增资质项" width="400px" center>
      <el-form ref="addAptitudeForm" :model="addAptitudeForm" size="small" :label-width="'100px'" :inline="true">
        <el-form-item label="资质项:">
          <el-select filterable v-model="addAptitudeForm.qualificationList" placeholder="请选择">
            <el-option v-for="item in aptitudeList" :key="item.QUALIFICATION_RECORD_ID" :label="item.QUALIFICATION_NAME"
              :value="item.QUALIFICATION_RECORD_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否为必传：" style="display:block">
          <el-radio-group v-model="addAptitudeForm.radioVal">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="addAptitudeDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleAddAptitude">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      currentPage: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      tableData: [],
      newTableData: [],
      aptitudeList: [],
      addAptitudeForm: {
        qualificationList: '',
        radioVal: '1',
      },
      addAptitudeDialog: false,
    };
  },
  created() {
    this.queryTable();
  },
  methods: {
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryTable();
    },
    sizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.queryTable();
    },
    // 进入页面拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 19,
        NATURE_RECORD_ID: Number(this.$route.params.id),
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result;
          this.newTableData = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
          this.totalCount = this.tableData.length;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.tableData = [];
        }
      });
    },
    // 新增资质项
    getAptitude() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 15,
        GYS_ID: Number(this.$route.params.gysId),
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.aptitudeList = result;
        }
      });
    },
    addCheckout() {
      this.getAptitude();
      this.addAptitudeDialog = true;
    },
    // 提交新增资质项
    handleAddAptitude() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 20,
        NATURE_RECORD_ID: Number(this.$route.params.id),
        STATUS: Number(this.addAptitudeForm.radioVal),
      };
      if (this.addAptitudeForm.qualificationList) {
        params.QUALIFICATION_RECORD_ID = this.addAptitudeForm.qualificationList;
      } else {
        this.$message.show({ text: '请选择资质', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addAptitudeDialog = false;
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 解除匹配资质
    remove(row) {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 21,
        RELATION_ID: row.RELATION_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '解除匹配成功', type: 'success' });
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/supplierManage/matchQualifications.vue